<template>
  <v-row justify="end" class="mr-12">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn class="text-capitalize text-white button-config" v-bind="props">
          Cadastrar Ator
          <v-icon right class="ml-1">mdi-plus</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Cadastrar Ator</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              validate-on="lazy submit"
              @submit.prevent="submitForm"
            >
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="nome"
                    required
                    label="Nome*"
                    :rules="nomeRules"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*Campo obrigatório</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue-darken-1" variant="text" @click="submitForm">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 * @module AtorModal
 * @desc Modal com o formulário para a criação de um ator.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o modal está visível.
 * @vue-data {string} [nome=''] - Nome do ator.
 * @vue-data {boolean} [isLoading] - Flag que indica se o ator ainda está
 * sendo criado.
 */
import axios from 'axios';

import store from '@/store/store';

export default {
  props: {
    idProjeto: {
      type: Number,
      required: true,
    },
  },
  emits: ['atorCriado'],
  data: () => ({
    dialog: false,
    nome: '',
    isLoading: false,
    nomeRules: [
      (v) => !!v || 'Nome é obrigatório',
      (v) => (v && v.length <= 20) || 'Nome deve ter no máximo 20 caracteres',
    ],
  }),
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza uma requisição HTTP para criar um novo ator.
     */
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;
      const regex = /[a-zA-Z]/;
      if (isValid) {
        const data = {
          // eslint-disable-next-line camelcase
          nome_ator: this.nome,
          // eslint-disable-next-line camelcase
          id_projeto: this.idProjeto,
        };

        try {
          console.log(regex.test(this.nome));
          if (!regex.test(this.nome)) {
            this.$toast.error(
              'Nome do ator não pode ter apenas numeros e caracteres especiais.',
            );

            return;
          } else if (this.nome.charAt(0) === ' ') {
            this.$toast.error(
              'Nome do ator não pode ser iniciado com espaços em branco.',
            );

            return;
          }
          this.isLoading = true;
          this.nome = '';
          this.dialog = false;
          const apiUrl = process.env.VUE_APP_API_URL;
          const response = await axios.post(
            `${apiUrl}/api/v1/ator/projeto/${this.idProjeto}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          this.$toast.success(response.data.msg);
          this.$emit('atorCriado');
          this.$router.push(`/projects/${this.idProjeto}/ator`);
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoading = false;
          this.dialog = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.button-config {
  background-color: #004984;
}
</style>
